
<div class="padding-20 ui-g" id="c3_viewCoupon_Modal">
 <!--
  <app-campaign-3-kontable 
  *ngIf="show.table"
  id="productsListTable"            
  [columns] = "[         
  { field: 'code', title: 'Codice' },
  { field: 'description', title: 'Descrizione' },
  { field: 'product_categories', title: 'Categoria' },
  { field: 'product_department', title: 'Reparto' },
  { field: 'barcode', title: 'Barcode' }
  ]"         
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="false"
  [service]="srvCampaign3"
  [fixedFilters]="filters"
  [methodsNames]="{ list: 'getProductItemComplete', sendExtSearchQuery: 'sendExtSearchQuery' }"
  [showSelectButton]="false"
  #productsListTable>


</app-campaign-3-kontable>  
-->
<app-campaign-3-kontable 
#couponTable 
id="couponsListTable"
*ngIf="show.table"
[title]="title" 
[columns]="[
      {field: 'coupon_code', title: 'campaign.couponCode'},
      {field: 'barcode', title: 'promotion.barCode'},
      {field: 'cust_name', title: 'campaign.customerName'},
      {field: 'cust_surname', title: 'campaign.customerSurname'},
      {field: 'emission_date_start', title: 'campaign.emissionStartDate', type: 'date', filterType: dateFilter},
      {field: 'emission_date_end', title: 'campaign.emissionEndDate', type: 'date', filterType: dateFilter},
      {field: 'fruition_date_start', title: 'campaign.fruitionStartDate', type: 'date', filterType: dateFilter},
      {field: 'fruition_date_end', title: 'campaign.fruitionEndDate', type: 'date', filterType: dateFilter},
      'card_no'
    ]" 
    [titles]="['loyalty.card_no']" 
    [service]="couponService" 
    [paginationType]="paginationType"
    [showRecoverButton]="false" 
    [showInfoButton]="false" 
    [showAddButton]="false" 
    [showDeleteButton]="false"
    [showDetailsButton]="false" 
    [showEditButton]="false"
    [filterBySingleColumn]="false">
    </app-campaign-3-kontable>
  
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/view-coupons/campaign-3-view-coupons.component.html